package com.essntl.features.address.ui

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import com.essntl.uikit.components.input.EsInput
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme

@Composable
fun AddressScreen(
    state: AddressState,
    onEvent: (AddressEvent) -> Unit,
    validation: AddressValidation,
    innerScreen: Boolean = false,
    modifier: Modifier = Modifier,
) {
    Column(
        verticalArrangement = Arrangement.Center,
        modifier = modifier
            .fillMaxWidth()
            .background(
                color = MaterialTheme.esColorScheme.bgSecondary,
                shape = RoundedCornerShape(EsConstants.RoundedCornerSize),
            )
            .clip(
                RoundedCornerShape(
                    topStart = 24.dp,
                    topEnd = 24.dp,
                ),
            )
            .padding(
                horizontal = if (innerScreen)
                    0f.spacing else
                    2.5f.spacing,
                vertical = 2.spacing,
            ),
    ) {
        EsInput(
            value = state.address.value.line1.orEmpty(),
            onValueChange = {
                validation.addressForm.line1.validate(it)

                onEvent(
                    AddressEvent.UpdateAddressFields(
                        state.address.value.copy(line1 = it),
                    ),
                )
            },
            label = "Address line 1",
            placeholder = "Enter address",
            message = "This field is required",
            state = validation.addressForm.line1.state,
            modifier = Modifier.fillMaxWidth(),
        )

        Spacer(modifier = Modifier.height(1.spacing))

        EsInput(
            value = state.address.value.line2.orEmpty(),
            onValueChange = {
                onEvent(
                    AddressEvent.UpdateAddressFields(
                        state.address.value.copy(line2 = it),
                    ),
                )
            },
            label = "Address line 2 (optional)",
            placeholder = "Enter address additional",
            modifier = Modifier.fillMaxWidth(),
        )

        Spacer(modifier = Modifier.height(1.spacing))

        Row(
            horizontalArrangement = Arrangement.spacedBy(3.spacing),
            verticalAlignment = Alignment.CenterVertically,
            modifier = Modifier.fillMaxWidth(),
        ) {
            EsInput(
                value = state.address.value.city.orEmpty(),
                onValueChange = {
                    validation.addressForm.city.validate(it)

                    onEvent(
                        AddressEvent.UpdateAddressFields(
                            state.address.value.copy(city = it),
                        ),
                    )
                },
                label = "City",
                placeholder = "Enter city",
                message = "This field is required",
                state = validation.addressForm.city.state,
                modifier = Modifier.weight(1f),
            )

            EsInput(
                value = state.address.value.state.orEmpty(),
                onValueChange = {
                    onEvent(
                        AddressEvent.UpdateAddressFields(
                            state.address.value.copy(state = it),
                        ),
                    )
                },
                label = "State (optional)",
                placeholder = "Enter state",
                modifier = Modifier.weight(1f),
            )
        }

        Spacer(modifier = Modifier.height(1.spacing))

        Row(
            horizontalArrangement = Arrangement.spacedBy(3.spacing),
            verticalAlignment = Alignment.CenterVertically,
            modifier = Modifier.fillMaxWidth(),
        ) {
            EsInput(
                value = state.address.value.zipCode.orEmpty(),
                onValueChange = {
                    onEvent(
                        AddressEvent.UpdateAddressFields(
                            state.address.value.copy(zipCode = it),
                        ),
                    )
                },
                label = "Zip Code",
                placeholder = "Enter zip code",
                modifier = Modifier.weight(1f),
            )

            EsInput(
                value = state.address.value.country.orEmpty(),
                onValueChange = {
                    validation.addressForm.country.validate(it)

                    onEvent(
                        AddressEvent.UpdateAddressFields(
                            state.address.value.copy(country = it),
                        ),
                    )
                },
                label = "Country",
                placeholder = "Enter country",
                message = "This field is required",
                state = validation.addressForm.country.state,
                modifier = Modifier.weight(1f),
            )
        }
    }
}